module.exports = __webpack_public_path__ + "img/logo.03f27ddf.svg";